var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 10 12",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.737 7.904c2.568 0 4.737.423 4.737 2.055C9.474 11.592 7.29 12 4.737 12 2.168 12 0 11.577 0 9.945c0-1.632 2.182-2.04 4.737-2.04zm0-7.904C6.477 0 7.87 1.413 7.87 3.175c0 1.762-1.394 3.175-3.134 3.175S1.603 4.937 1.603 3.175C1.603 1.413 2.997 0 4.737 0z"
  })));
}

export default __webpack_public_path__ + "dcd9529135956864c7e1fd1aa228a20d.svg";
export { SvgUser as ReactComponent };